import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { colors } from '../../theme';

type Props = {
  circleText: string;
  title: string;
  subtitle: string;
  description: string;
  link?: string;
  linkText?: string;
};

export const Timeline = (props: Props) => {
  return (
    <Stack flex={1} alignItems="center" gap={2}>
      <Stack direction="row" alignItems="center" width="100%">
        <Stack
          width={40}
          height={40}
          justifyContent="center"
          alignItems="center"
          p={1}
          color={colors.primary}
          border={`2px solid ${colors.primary}`}
          borderRadius="100%"
        >
          <Typography fontWeight="bold">{props.circleText}</Typography>
        </Stack>

        <Box flex={1} height={2} bgcolor={colors.primary} />
      </Stack>

      <Stack pr={3.5} gap={2}>
        <Stack>
          <Typography variant="h6">{props.title}</Typography>
          <Typography fontSize={14} fontWeight="600" lineHeight={1.25}>
            {props.subtitle}
          </Typography>
        </Stack>

        {props.link && props.linkText && (
          <Link to={props.link}>
            <Button variant="contained" sx={{ fontSize: 12 }}>
              {props.linkText}
            </Button>
          </Link>
        )}

        <Typography
          color="rgba(30, 20, 5, 0.8)"
          sx={{ fontSize: { xs: 12, lg: 13 } }}
        >
          {props.description}
        </Typography>
      </Stack>
    </Stack>
  );
};
